// extracted by mini-css-extract-plugin
module.exports = {"remove":"TagView_remove__2JVRQ"};